module.exports = __webpack_public_path__ + "media/images/ecalls/icon_checked_circle_orange-e0b48f9ecd139b6dd0dc6868d9773d5f.png";